export const enumPermisosCreditoPdp = Object.freeze({
  REALIZAR_CREDITO_FACIL: 34000,
  PAGO_CREDITO_FACIL: 34002,
  EXTRACTOS_CREDITOS_COMERCIO: 34005,
  VALIDACION_DOCUMENTOS: 34006,
});

export const enumPermisosCreditoPdpAdmin = Object.freeze({
  GESTION_TERCEROS_CREDITO_FACIL: 34001,
  CARGUE_MASIVO_CREDITO_FACIL: 34004,
  VALIDACION_DOCUMENTOS_ADMIN: 34007,
  DESEMBOLSO_CEA_CRC: 34003,
});
